export default __webpack_public_path__ + "static/media/Crown of the Dragon King.80192f4e.jpg";